// @flow

import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import Text from './Typography';
import Icon from './Icon';

import articleRefs from '../../data/articles';

import urineIcon from '../../assets/images/articles/urine.png';
import clinicalIcon from '../../assets/images/articles/clinical-notes.png';
import labIcon from '../../assets/images/articles/lab-results.png';
import chemistryIcon from '../../assets/images/articles/chemistry.png';
import CBCIcon from '../../assets/images/articles/cbc.png';
import imagingIcon from '../../assets/images/articles/imaging.png';

type Props = {
  resourceType: string,
  nestedResourceTypes: string[],
  shared: Boolean // whether the record to present these articles for belongs to the user or has been shared
} & WithTranslation

type State = {
  relatedArticles: Object[],
  iconArray: Array
}
class Articles extends React.Component<Props, State> {
  state: State = {
    relatedArticles: [],
    iconArray: [urineIcon, clinicalIcon, labIcon, chemistryIcon, CBCIcon, imagingIcon]
  }

  componentWillMount() {
    const { resourceType, nestedResourceTypes } = this.props;
    const relatedArticles = articleRefs.filter((article) =>
      resourceType === article.type ||
      (nestedResourceTypes && nestedResourceTypes.includes(article.type)));
    this.setState({ relatedArticles });
  }

  props: Props

  render() {
    const { t } = this.props;
    const articles = this.state.relatedArticles.map((article, index) => (
      <a key={index} href={article.link} className='article' target='_blank' rel='noopener noreferrer'>
        <div className='article__content'>
          <img className='article__img' src={this.state.iconArray[article.index]} alt={t('alt_error')} />
          <div className='article__text'>
            <Text paragraph bold className='article__title'>{t(article.index.toString()) || article.title}</Text>
            <Text link className='is-link'>{t('read_now')}</Text>
          </div>
        </div>
      </a>
    ));

    return this.state.relatedArticles.length > 0 && (
      <div>
        <div>
          <Icon size='x-small' className='article__icon' name={'ellipse'} />
          <Icon size='x-small' className='article__icon' name={'ellipse'} />
          <Icon size='x-small' className='article__icon' name={'ellipse'} />
        </div>
        <Text h3>{this.props.shared ? t('understanding_shared_record') : t('understanding_your_record')}</Text>
        {articles}
      </div>
    );
  }
}

export default withTranslation('articles')(Articles);



// WEBPACK FOOTER //
// ./src/components/shared/Articles.js